<template>
		<v-menu v-model="visible" offset-y :attach="attachTo" :close-on-content-click="false"  :close-on-click="true" :max-height="maxHeight" :min-width="minWidth">
			<template v-if="!inside"
				v-slot:activator="{ on, attrs }"
			>
				<div
					@click="all ? visible = true : null"
					v-bind="attrs"
					class="d-flex flex-row">
					<v-text-field
						v-model="search"
						:placeholder="finalPlaceholder"
						@click="onClick"
						@input="onInput"
						v-on="on"
						outlined
						dense
						prepend-inner-icon="mdi-magnify"
						hide-details
					>
						<template v-if="loading"  slot="append">
							<v-progress-circular

								indeterminate
								size="20"
							></v-progress-circular>
						</template>
					</v-text-field>
				</div>
			</template>
			<v-list v-if="inside">
				<v-text-field
					v-model="search"
					@keyup="searchUser()"
					:placeholder="finalPlaceholder"
					outlined
					dense
					prepend-inner-icon="mdi-magnify"
					hide-details
					class="mx-3 mt-2"
				>
					<template v-if="loading" slot="append">
						<v-progress-circular
							v-if="loading"
							indeterminate
							size="20"
						></v-progress-circular>
					</template>
				</v-text-field>
			</v-list>
			<div class="relative">
				<v-list dense v-if="users.length" class="relative">
					<v-overlay
						v-if="loading"
						:value="true"
						absolute
						:dark="false"
						light
						color="white"
						opacity="0.8"
						>
					</v-overlay>

					<v-list-item
						v-for="(user, i) in searchedUsers"
						:key="i"
						@click="selected(user)"
						class="py-1"
					>
						<avatar :user="user" sm class="mr-2" /> {{ user.name || user.email }}
					</v-list-item>
				</v-list>
				<v-list v-if="!users.length && !loading && search && dirty" dense>
					<v-list-item disabled>
						Brak
					</v-list-item>
				</v-list>
			</div>
		</v-menu>

</template>

<script>
import _ from 'lodash';
import Avatar from '@/components/Avatar'
export default {
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		inside: {
			type: Boolean,
			default: false
		},
		attach: {
			type: String,
		},
		minWidth: {
			type: [String, Number]
		},
		maxWidth: {
			type: [String, Number]
		},
		maxHeight: {
			type: [String, Number],
			default: 400
		},
		all: {
			type: Boolean,
			default: false
		}
	},
	components: {
		Avatar
	},
	data() {
		return {
			visible: false,
			search: '',
			loading: false,
			users: [],
			dirty: false,
		}
	},
	computed: {
		finalPlaceholder() {
			return this.placeholder || this.$vuetify.lang.t('$vuetify.users.searchUser')
		},
		searchedUsers() {
			if(!this.all) {
				return this.users.slice(0, 50);
			}
			return _.orderBy(this.users, 'name');

		},
		attachTo() {
			if(this.attach) {
				return `#${this.attach}`
			}
			return false;
		}
	},
	methods: {
		onClick() {
			this.visible = true;
			if(this.all) {
				if(!this.users.length) {
					this.searchUser();
				}

			}
		},
		show() {
			this.visible = true;
		},
		onInput() {
			if(!this.all) {
				if(this.search) {
					this.searchUser();
				}
				else {
					this.dirty = false;
				}
			}
			else {
				this.searchUser();
			}
		},
		selected(item) {
			this.$emit('selected', item);
			this.search = '';
			this.users = [];
			this.visible = false;
		},
		async searchUser() {
			if(this.all || (!this.all && this.search)) {
				this.loading = true;
				let data = await this.$store.dispatch('user/searchUser', {
					name: this.search
				});
				if(data.data) {
					this.dirty = false;
					this.users = data.data;
					this.visible = true;
				}
				else {
					this.users = []
				}


				this.loading = false;
			}
			else {
				this.dirty = true;
				this.users = [];
				this.visible = false;
			}

		}
	},
	created() {
		this.searchUser = _.debounce(this.searchUser, 400);
	}
}
</script>
